import { format, parse, parseISO } from 'date-fns';
import { ptBR, enUS, es } from 'date-fns/locale';
import { utcToZonedTime } from "date-fns-tz";

interface Conversion<T, R> {
    convertToUTC(value: T): R
    utcStringToYearMonthDay(value: T): R
    formatDateWithOffset(value: T): R
    formatDateToString(value: T): R
    formatMonthToString(value: T): R
    formatMonthDayDate(value: T): R
    formatFeedbackDate(value: string): { date: string; time: string };
}

export class FnsDateSingleton implements Conversion<string | Date, string> {
  private _locale: Locale 

  constructor(language: string) {
    if(language.includes('pt')) {
      this._locale = ptBR
    } else if(language.includes('en')) {
      this._locale = enUS
    } else if(language.includes('es')) {
      this._locale = es
    } else {
      this._locale = enUS
    }
  }

  convertToUTC(value: string): string {
      const parsedDate = parse(value, 'yyyy-MM-dd', new Date())
      const utcDate = utcToZonedTime(parsedDate, 'UTC');
      const formattedDate = format(utcDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'');
      return formattedDate;
  }

  utcStringToYearMonthDay(value: string): string {
    const utcDate = parseISO(value);
    const formattedDate = format(utcDate, 'yyyy-MM-dd');
    return formattedDate
  }

  formatDateWithOffset(value: string): string {
    const date = new Date(value)
    const result = format(date, 'MM/dd/yyyy HH:mm:ss', {locale: this._locale})
    return result
  }

  formatDateToString(value: Date): string {
    let dateFormat = 'dd/MM/yy';
    if (this._locale === enUS) {
        dateFormat = 'MM/dd/yy';
    }
    
    const startedDate = format(value, dateFormat, { locale: this._locale });
    
    return startedDate;
  }

  formatMonthToString(value: string): string {
    const date = new Date(value);
    let dateFormat = 'd MMM';
    if (this._locale === enUS) {
      dateFormat = 'MMM d';
    }

    const startedDate = format(date, dateFormat, { locale: this._locale });
    
    return `${startedDate}`;
  }

  formatMonthDayDate(dateString: string): string {
    const [month, day] = dateString.split('-');

    if (this._locale === enUS) {
      return `${month}-${day}`;
    } else {
      return `${day}-${month}`;
    }
  }

  formatFeedbackDate(value: string): { date: string, time: string } {
    const dateObj = parseISO(value);

    let dateFormat = 'MM/dd/yyyy';
    let timeFormat = 'hh:mm a'; 
    if (this._locale === es || this._locale === ptBR) {
        dateFormat = "dd/MM/yyyy";
        timeFormat = "HH:mm";  
    }

    const date = format(dateObj, dateFormat, { locale: this._locale });
    const time = format(dateObj, timeFormat, { locale: this._locale });

    return { date, time };
  }
} 